export default __webpack_public_path__ + "static/media/slide-03.7dfadec0.jpg";